type ColumnWidthSource = {
    width?: number;
};

export const getMinTableScrollWidth = (columns: readonly ColumnWidthSource[], selectionColumnWidth: number): number =>
    selectionColumnWidth +
    columns.reduce((total, column) => total + (typeof column.width === "number" ? column.width : 0), 0);
